import React, { useCallback, useEffect, useState } from "react";
import SubNav from "../../../Shared/SubNav";
import { useLocation, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import io from "socket.io-client";
import { IoIosArrowDropright, IoIosArrowDropleft } from "react-icons/io";
import socket from "../../../context/socket";
import axios from "axios";
import { MdOutlineCancel } from "react-icons/md";
import Chart from "react-apexcharts";
import AIDWModal from "./AIDWModal";
import OLIDWModal from "./OLIDWModal";
import MDWModal from "./MDWModal";
import IDWModal from "./IDWModal";
import { string } from "yup";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import { capitalizeText } from "../../../utils/inputsValidation";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../utils/api";
const Graph = ({ isDarkMode }) => {
  const location = useLocation();
  const [childrenData, setChildrenData] = useState([]);
  // console.log("childrenData",childrenData)
  const roomId = new URLSearchParams(location.search).get("clientId");
  const navigate = useNavigate();
  // State variables for input values
  const [childrenFees, setChildrenFees] = useState([]);
  // console.log("childrenFees",childrenFees)
  const [isNext, setIsNext] = useState(false);
  const [groceryAmount, setGroceryAmount] = useState("");
  const [homeRunningAmount, setHomeRunningAmount] = useState("");
  const [transportationAmount, setTransportationAmount] = useState("");
  const [monthlyIncome, setMonthlyIncome] = useState(null);
  const [houseRentedAmount, setHouseRentedAmount] = useState("");
  const [homeLoan, setHomeLoan] = useState("");
  const [vehicleLoan, setVehicleLoan] = useState("");
  const [healthInsurance, setHealthInsurance] = useState("");

  const [isThrough, setThrough] = useState("");
  console.log('isThrough',isThrough);
  

  const [futureGoals, setFutureGoals] = useState("");
  const [outsideFinEdge, setOutsideFinEdge] = useState("");

  const [addtionInc, setAdditionalInc] = useState([]);
  const [additionalIncomeFlag, setAdditionalIncomeFlag] = useState("");
  const [otherLoanInc, setotherLoanInc] = useState([]);
  const [otherLoanFlag, setOtherLoanFlag] = useState("");
  const [addMiscellaneousAmountInc, setAddMiscellaneousAmountInc] = useState(
    []
  );
  const [addMiscellaneousAmountFlag, setAddMiscellaneousAmountFlag] = useState("");
  const [saveItemsInc, setSaveItemsInc] = useState([]);
  console.log("saveItemsIncccc",saveItemsInc)

  const [errors, setErrors] = useState({});
  const [subNavRoute, setSubNavRoute] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  // console.log('saveItemsInc', saveItemsInc);
  const [clientData, setClientData] = useState([]);


  console.log("childerenData",childrenData)

  console.log("addMiscellaneousAmountFlag", addMiscellaneousAmountFlag, addMiscellaneousAmountInc);

  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

   const {
      clientData: Cdata,
  
    } = useSelector((state) => state.client);

    
  useEffect(() => {
    try {
      const clientDataOnth = Cdata?.cash_flow || [];
      setChildrenData(Cdata?.children || []);
      setClientData(clientDataOnth);

      const getAmount = (field) => clientDataOnth.find(item => item.field === field)?.amount || "";
      const getLabel = (field) => clientDataOnth.find(item => item.field === field)?.label || "";
      // console.log("outside_FinEdge", getLabel("outside_FinEdge"));

      setMonthlyIncome(getAmount("monthly_income"));
      const childrenFeesOnthe = clientDataOnth
        .filter((item) => item.field === "education")
        .map((item) => ({
          ...item,
          amount: item?.amount || 0, // fallback to 0
        }));

      setChildrenFees(childrenFeesOnthe);

      setGroceryAmount(getAmount("grocery"));
      setHomeRunningAmount(getAmount("home_running"));
      setTransportationAmount(getAmount("transportation"));
      setHouseRentedAmount(getAmount("house_rent"));
      setHomeLoan(getAmount("home_loan"));
      setVehicleLoan(getAmount("vehicle_loan"));
      setHealthInsurance(getAmount("health_insurance"));
      setFutureGoals(getAmount("inside_FinEdge"));
      setThrough(getLabel("outside_FinEdge"));
      setOutsideFinEdge(getAmount("outside_FinEdge"));

      // Checkbox setters
      setRentedHouseChecked(getAmount("house_rent") !== "0" && !!getAmount("house_rent"));
      setHomeLoanChecked(getAmount("home_loan") !== "0" && !!getAmount("home_loan"));
      setVehicleLoanChecked(getAmount("vehicle_loan") !== "0" && !!getAmount("vehicle_loan"));
      setHealthInsuranceChecked(getAmount("health_insurance") !== "0" && !!getAmount("health_insurance"));

      // Additional Income
      const additionalIncome = clientDataOnth.filter(item => item.field === "additional_income");
      console.log('clientDataOnth',clientDataOnth);
      setAdditionalInc(additionalIncome)
      // setAdditionalInc((prev) => {
      //   const label = additionalIncome[0]?.label || "";
      //   const amount = additionalIncome[0]?.amount || "";
      // console.log('clientDataOnth',label,amount);

      
      //   // Don't add if either is blank
      //   if (!label || !amount) return prev;
      
      //   const exists = prev.some((item) => item.label === label && item.amount === amount);
      //   if (exists) return prev;
      
      //   return [...prev, { label, amount }];
      // });
      
      
      
      setAdditionalIncomeFlag(additionalIncome.length > 0 ? "Yes" : "No");

      // Other Loan
      const otherLoan = clientDataOnth.filter(item => item.field === "other_loan");
      setotherLoanInc(otherLoan);
      // setotherLoanInc((prev) => {
      //   const label = otherLoan[0]?.label || "";
      //   const amount = otherLoan[0]?.amount || "";
      // console.log('clientDataOnth',label,amount);

      
      //   // Don't add if either is blank
      //   if (!label || !amount) return prev;
      
      //   const exists = prev.some((item) => item.label === label && item.amount === amount);
      //   if (exists) return prev;
      
      //   return [...prev, { label, amount }];
      // });
      setPersonalLoanChecked(otherLoan.length > 0);
      setOtherLoanFlag(otherLoan.length > 0 ? "Yes" : "No");

      // Miscellaneous
      const miscellaneous = clientDataOnth.filter(item => item.field === "miscellaneous");
      setAddMiscellaneousAmountInc(miscellaneous);

      setAddMiscellaneousAmountFlag(miscellaneous.length > 0 ? "Yes" : "No");
      // console.log('clientDataOnth',miscellaneous);

      // Savings
      const savingItems = clientDataOnth.filter(item => item.label2 === "items");
      console.log('savingItems',savingItems);

      // setSaveItemsInc(savingItems);

      // setSaveItemsInc((prev) => {
      //   const updated = [...prev];
      //   savingItems.forEach(({ label, amount, field }) => {
          
      //     const labelText = label?.trim();
      //     const amountVal = amount?.trim();
      //     const fieldVal = field?.trim();
      
      //     // Skip if any value is blank  !labelText ||
      //     if ( !amountVal || !fieldVal) return;
      
      //     const exists = updated.some(
      //       (item) =>
      //         item.label === labelText &&
      //         item.amount === amountVal &&
      //         item.field === fieldVal
      //     );
          
      //     if (!exists) {
      //       updated.push({ label: labelText, amount: amountVal, field: fieldVal });
      //     }
      //   });
      
      //   return updated;
      // });

      setSaveItemsInc(
        savingItems.map(({ label, amount, field }) => ({
          label: label?.trim(),
          amount: amount?.trim(),
          field: field?.trim(),
        }))
      );
      
      

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [Cdata]);
    


  const dispatch = useDispatch();



  useEffect(() => {
    dispatch(fetchClientData(roomId));
  }, [dispatch]);

  // State variables for checkbox states
  const [rentedHouseChecked, setRentedHouseChecked] = useState(false);
  const [homeLoanChecked, setHomeLoanChecked] = useState(false);
  const [vehicleLoanChecked, setVehicleLoanChecked] = useState(false);
  const [personalLoanChecked, setPersonalLoanChecked] = useState(false);
  const [healthInsuranceChecked, setHealthInsuranceChecked] = useState(false);

  console.log('vehicleLoanChecked',vehicleLoanChecked);
  

  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  // Debounced function to emit data
  const sendDataToServer = useCallback(
    debounce((data) => {
      socket.emit("message", { room: roomId, data });
      console.log("emited data", data);
    }, 500),

    [roomId]
  );



  useEffect(() => {
    sendDataToServer({
      currentPage,
      childrenFees,
      groceryAmount,
      homeRunningAmount,
      transportationAmount,
      monthlyIncome,
      houseRentedAmount,
      rentedHouseChecked,
      homeLoan,
      homeLoanChecked,
      vehicleLoan,
      vehicleLoanChecked,
      personalLoanChecked,
      healthInsurance,
      healthInsuranceChecked,
      additionalIncomeFlag,
      addtionInc,
      otherLoanFlag,
      otherLoanInc,
      addMiscellaneousAmountFlag,
      addMiscellaneousAmountInc,
      futureGoals,
      outsideFinEdge,
      isThrough,
      saveItemsInc,
      subNavRoute,
    });
  }, [
    sendDataToServer,
    currentPage,
    childrenFees,
    groceryAmount,
    homeRunningAmount,
    transportationAmount,
    monthlyIncome,
    houseRentedAmount,
    rentedHouseChecked,
    homeLoan,
    homeLoanChecked,
    vehicleLoan,
    vehicleLoanChecked,
    personalLoanChecked,
    healthInsurance,
    healthInsuranceChecked,
    additionalIncomeFlag,
    addtionInc,
    otherLoanInc,

    otherLoanFlag,

    addMiscellaneousAmountFlag,
    addMiscellaneousAmountInc,

    futureGoals,
    outsideFinEdge,
    isThrough,
    saveItemsInc,
    subNavRoute,
  ]);

  //checkbox handle set 0 when uncheck
  const handleRentedHouseChange = () => {
    setRentedHouseChecked((prevState) => !prevState);
    setHouseRentedAmount("0");
  };

  const handleHomeLoanChange = () => {
    setHomeLoanChecked((prevState) => !prevState);
    setHomeLoan("0");
  };

  const handleVehicleLoanChange = () => {
    setVehicleLoanChecked((prevState) => !prevState);
    setVehicleLoan("0");
  };

  const handlePersonalLoanChange = () => {
    setPersonalLoanChecked((prevState) => !prevState);
    setotherLoanInc([]);
  };

  const handleHealthInsuranceChange = () => {
    setHealthInsuranceChecked((prevState) => !prevState);
    setHealthInsurance("0");
  };

  // const [errors, setErrors] = useState({});


  const validateFields = () => {
    let newErrors = {};
    let errorFields = []; // Array to hold the field names with errors

    // Validate monthlyIncome
    if (!monthlyIncome) {
      newErrors.monthlyIncome = "Monthly income is required.";
      errorFields.push('Monthly Income');
    }

    // Validate groceryAmount
    if (!groceryAmount) {
      newErrors.groceryAmount = "Monthly grocery bill is required.";
      errorFields.push('Monthly Grocery Bill');
    }

    // Validate additional incomes
    addtionInc &&
      addtionInc.forEach((income, index) => {
        if (!income.label) {
          newErrors[`label${index}`] = `Additional income is required.`;
          errorFields.push(`Additional Income ${index + 1} Label`);
        }
        if (!income.amount) {
          newErrors[`amount${index}`] = `Additional income amount is required.`;
          errorFields.push(`Additional Income ${index + 1} Amount`);
        }
      });

    // Validate other loans
    otherLoanInc.forEach((loan, index) => {
      if (!loan.label) {
        newErrors[`otherLoanLabel${index}`] = `Other loan is required.`;
        errorFields.push(`Other Loan ${index + 1} Label`);
      }
      if (!loan.amount) {
        newErrors[`otherLoanAmount${index}`] = `Other loan amount is required.`;
        errorFields.push(`Other Loan ${index + 1} Amount`);
      }
    });

    // Validate miscellaneous amounts
    addMiscellaneousAmountInc.forEach((misc, index) => {
      if (!misc.label) {
        newErrors[`miscLabel${index}`] = `Label for miscellaneous ${index + 1} is required.`;
        errorFields.push(`Miscellaneous ${index + 1} Label`);
      }
      if (!misc.amount) {
        newErrors[`miscAmount${index}`] = `Amount for miscellaneous ${index + 1} is required.`;
        errorFields.push(`Miscellaneous ${index + 1} Amount`);
      }
    });

    // Validate saving items
    saveItemsInc.forEach((item, index) => {
      if (!item.amount) {
        newErrors[`saveAmount${index}`] = `Amount for saving item ${index + 1} is required.`;
        errorFields.push(`Saving Item ${index + 1} Amount`);
      }
      // if (!item.label) {
      //   newErrors[`saveLabel${index}`] = `Label for saving item ${index + 1} is required.`;
      //   errorFields.push(`Saving Item ${index + 1} Label`);
      // }
      if (!item.field) {
        newErrors[`saveField${index}`] = `Field for saving item ${index + 1} is required.`;
        errorFields.push(`Saving Item ${index + 1} Field`);
      }
    });

    setErrors(newErrors);

    // Check if there are any errors
    if (Object.keys(newErrors).length > 0) {
      // Create an error message that lists all the fields with errors
      const errorMessage = `Please fill out the following fields:\n\n${errorFields.join('\n')}`;

      // Show SweetAlert with the error fields
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: errorMessage,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn  ',
        },
      });
      return false;  // Optionally return false to prevent form submission
    }

    return true;  // No errors, proceed
  };


  //   // console.log("nn",name);
  //   const saveUserAbout = async () => {
  //     try {
  //       // const additionalIncomeData =
  //       // additionalIncomeFlag === "No"
  //       //   ? []
  //       //   : addtionInc.map((income) => ({
  //       //       _id: "",
  //       //       field: "additional_income",
  //       //       label:capitalizeWords(income.label),
  //       //       source_type: "additional_income",
  //       //       frequency: "monthly",
  //       //       amount: income.amount,
  //       //     }));
  //       const allDataa = {
  //         _id: String(roomId),
  //         cash_flow: [
  //           {
  //             _id: "",
  //             field: "monthly_income",
  //             label: "Monthly Income",
  //             source_type: "income",
  //             frequency: "monthly",
  //             amount: monthlyIncome,
  //           },
  //           // ...additionalIncomeData,
  //           ...childrenData.map((child) => ({
  //             _id: "",
  //             field: "education",
  //             label: `Education for ${child.name}`,
  //             source_type: "expense",
  //             child_id: child._id,
  //             frequency: "monthly",
  //             amount:
  //               childrenFees.find((fee) => fee.child_id === child._id)?.amount ,
  //           })),
  //           {
  //             _id: "",
  //             field: "grocery",
  //             label: "Grocery",
  //             source_type: "expense",
  //             frequency: "monthly",
  //             amount: groceryAmount,
  //           },
  //         ]}
  //       const response = await axios.post(
  //        "advisor/save_user_about_5",allDataa

  //       );
  //       console.log(response.data); 
  //     } catch (error) {
  //       console.error("Error saving user about:", error);
  //     }
  //   };
  //   const timer = setTimeout(() => {
  //     saveUserAbout();
  //     console.log("monthlyIncome", monthlyIncome);
  //   }, 1000); // 1000 milliseconds = 1 seconds

  //   return () => clearTimeout(timer);

  // }, [monthlyIncome,childrenFees,groceryAmount,addtionInc]); 


  const saveUserAbout = () => {


    const roomId = new URLSearchParams(window.location.search).get("clientId");
    // Function to capitalize each word
    const capitalizeWords = (str) =>
      str.replace(/\b\w/g, (char) => char.toUpperCase());

    // Conditional check for addMiscellaneousAmountInc
    const additionalIncomeData =
      additionalIncomeFlag === "No"
        ? []
        : addtionInc.map((income) => ({
          _id: "",
          field: "additional_income",
          label: (income.label),
          source_type: "additional_income",
          frequency: "monthly",
          amount: income.amount,
        }));

    const otherLoanData =
      otherLoanFlag === "No"
        ? []
        : otherLoanInc.map((income) => ({
          _id: "",
          field: "other_loan",
          label: (income.label),
          source_type: "emi",
          frequency: "monthly",
          amount: income.amount,
        }));

    const addMiscellaneousAmountData =
      addMiscellaneousAmountFlag === "No"
        ? []
        : addMiscellaneousAmountInc.map((income) => ({
          _id: "",
          field: "miscellaneous",
          label: (income.label),
          source_type: "additional_expense",
          frequency: "monthly",
          amount: income.amount,
        }));


    const transformedItems = saveItemsInc.map((income, index) => ({
      _id: "",
      field: income.field,
      label: income.label,
      source_type: "saving",
      frequency: "monthly",
      label2: "items",
      amount: income.amount,
    }));

    const allData = {
      _id: String(roomId),
      cash_flow: [
        {
          _id: "",
          field: "monthly_income",
          label: "Monthly Income",
          source_type: "income",
          frequency: "monthly",
          amount: monthlyIncome,
        },
        // ...addtionInc.map((income) => ({
        //   _id: "",
        //   field: "additional_income",
        //   label: income.label,
        //   source_type: "additional_income",
        //   frequency: "monthly",
        //   amount: income.amount,
        // })),
        ...additionalIncomeData,
        // {
        //   _id: "",
        //   field: "additional_income_availability",
        //   label: "additionalIncomeFlag",
        //   source_type: "income",
        //   frequency: "monthly",
        //   amount: additionalIncomeFlag,
        // },
        ...childrenData.map((child) => ({
          _id: "",
          field: "education",
          label: `Education for ${child.name}`,
          source_type: "expense",
          child_id: child._id,
          frequency: "monthly",
          amount:
            childrenFees.find((fee) => fee.child_id === child._id)?.amount,
        })),
        {
          _id: "",
          field: "grocery",
          label: "Grocery",
          source_type: "expense",
          frequency: "monthly",
          amount: groceryAmount,
        },
        {
          _id: "",
          field: "home_running",
          label: "Home running",
          source_type: "expense",
          frequency: "monthly",
          amount: homeRunningAmount,
        },
        {
          _id: "",
          field: "transportation",
          label: "Transportation",
          source_type: "expense",
          frequency: "monthly",
          amount: transportationAmount,
        },
        {
          _id: "",
          field: "house_rent",
          label: "House Rent",
          source_type: "expense",
          frequency: "monthly",
          amount: houseRentedAmount,
        },
        {
          _id: "",
          field: "home_loan",
          label: "Home Loan",
          source_type: "emi",
          frequency: "monthly",
          amount: homeLoan,
        },
        {
          _id: "",
          field: "vehicle_loan",
          label: "Vehicle Loan",
          source_type: "emi",
          frequency: "monthly",
          amount: vehicleLoan,
        },
        {
          _id: "",
          field: "health_insurance",
          label: "Health Insurance",
          source_type: "expense",
          frequency: "yearly",
          amount: healthInsurance,
        },
        // {
        //   _id: "",
        //   field: "other_loan_availability",
        //   label: "otherLoanFlag",
        //   source_type: "loan",
        //   frequency: "monthly",
        //   amount: otherLoanFlag,
        // },
        ...otherLoanData,
        // {
        //   _id: "",
        //   field: "miscellaneous_amount_availability",
        //   label: "addMiscellaneousAmountFlag",
        //   source_type: "loan",
        //   frequency: "monthly",
        //   amount: addMiscellaneousAmountFlag,
        // },
        ...addMiscellaneousAmountData,
        ...transformedItems,

        {
          _id: "",
          field: "inside_FinEdge",
          label: "inside_FinEdge",
          source_type: "saving",
          frequency: "monthly",
          amount: futureGoals,
        },
        {
          _id: "",
          field: "outside_FinEdge",
          label: (isThrough),
          source_type: "saving",
          frequency: "monthly",
          amount: outsideFinEdge,
        },
        // {
        //   _id: "",
        //   field: "Through",
        //   label: isThrough,
        //   source_type: "saving",
        //   frequency: "monthly",
        //   amount: isThrough,
        // },

        // ...saveItemsInc.map((income, index) => ({
        //   _id: "",
        //   field: income.field,
        //   label: (income.label),
        //   source_type: "saving",
        //   frequency: "monthly",
        //   label2: "items",
        //   amount: income.amount,
        // })),


      ],
    };
    console.log("allData", allData, transformedItems);

    api
      .post(
       "advisor/save_user_about_5",
        allData
      )
      .then((response) => {
        // setSaveItemsInc([])
        // console.log("empty ho gaya")
      })
      .catch((error) => {
        console.error("Error saving message:", error);
      });

    // console.log("allData", allData);
  };
  
  const handleNext = () => {
    setIsNext(true)
    if (!validateFields()) {
      setIsNext(false)
      return;
    }

    const roomId = new URLSearchParams(window.location.search).get("clientId");
    const nextUrl = "/personal-finance?clientId=" + roomId;
        const nextUrl2 = "/personal-finance" ;

    // Function to capitalize each word
    const capitalizeWords = (str) =>
      str.replace(/\b\w/g, (char) => char.toUpperCase());

    // Conditional check for addMiscellaneousAmountInc
    const additionalIncomeData =
      additionalIncomeFlag === "No"
        ? []
        : addtionInc.map((income) => ({
          _id: "",
          field: "additional_income",
          label: (income.label),
          source_type: "additional_income",
          frequency: "monthly",
          amount: income.amount,
        }));

    const otherLoanData =
      otherLoanFlag === "No"
        ? []
        : otherLoanInc.map((income) => ({
          _id: "",
          field: "other_loan",
          label: (income.label),
          source_type: "emi",
          frequency: "monthly",
          amount: income.amount,
        }));

    const addMiscellaneousAmountData =
      addMiscellaneousAmountFlag === "No"
        ? []
        : addMiscellaneousAmountInc.map((income) => ({
          _id: "",
          field: "miscellaneous",
          label: (income.label),
          source_type: "additional_expense",
          frequency: "monthly",
          amount: income.amount,
        }));


        const transformedItems = saveItemsInc.map((income, index) => ({
          _id: "",
          field: income.field,
          label: income.label,        
          source_type: "saving",
          frequency: "monthly",
          label2: "items",
          amount: income.amount,
        }));
        
    const allData = {
      _id: String(roomId),
      cash_flow: [
        {
          _id: "",
          field: "monthly_income",
          label: "Monthly Income",
          source_type: "income",
          frequency: "monthly",
          amount: monthlyIncome,
        },
        // ...addtionInc.map((income) => ({
        //   _id: "",
        //   field: "additional_income",
        //   label: income.label,
        //   source_type: "additional_income",
        //   frequency: "monthly",
        //   amount: income.amount,
        // })),
        ...additionalIncomeData,
        // {
        //   _id: "",
        //   field: "additional_income_availability",
        //   label: "additionalIncomeFlag",
        //   source_type: "income",
        //   frequency: "monthly",
        //   amount: additionalIncomeFlag,
        // },
        ...childrenData.map((child) => ({
          _id: "",
          field: "education",
          label: `Education for ${child.name}`,
          source_type: "expense",
          child_id: child._id,
          frequency: "monthly",
          amount:
            childrenFees.find((fee) => fee.child_id === child._id)?.amount,
        })),
        {
          _id: "",
          field: "grocery",
          label: "Grocery",
          source_type: "expense",
          frequency: "monthly",
          amount: groceryAmount,
        },
        {
          _id: "",
          field: "home_running",
          label: "Home running",
          source_type: "expense",
          frequency: "monthly",
          amount: homeRunningAmount,
        },
        {
          _id: "",
          field: "transportation",
          label: "Transportation",
          source_type: "expense",
          frequency: "monthly",
          amount: transportationAmount,
        },
        {
          _id: "",
          field: "house_rent",
          label: "House Rent",
          source_type: "expense",
          frequency: "monthly",
          amount: houseRentedAmount,
        },
        {
          _id: "",
          field: "home_loan",
          label: "Home Loan",
          source_type: "emi",
          frequency: "monthly",
          amount: homeLoan,
        },
        {
          _id: "",
          field: "vehicle_loan",
          label: "Vehicle Loan",
          source_type: "emi",
          frequency: "monthly",
          amount: vehicleLoan,
        },
        {
          _id: "",
          field: "health_insurance",
          label: "Health Insurance",
          source_type: "expense",
          frequency: "yearly",
          amount: healthInsurance,
        },
        // {
        //   _id: "",
        //   field: "other_loan_availability",
        //   label: "otherLoanFlag",
        //   source_type: "loan",
        //   frequency: "monthly",
        //   amount: otherLoanFlag,
        // },
        ...otherLoanData,
        // {
        //   _id: "",
        //   field: "miscellaneous_amount_availability",
        //   label: "addMiscellaneousAmountFlag",
        //   source_type: "loan",
        //   frequency: "monthly",
        //   amount: addMiscellaneousAmountFlag,
        // },
        ...addMiscellaneousAmountData,
        ...transformedItems,

        {
          _id: "",
          field: "inside_FinEdge",
          label: "inside_FinEdge",
          source_type: "saving",
          frequency: "monthly",
          amount: futureGoals,
        },
        {
          _id: "",
          field: "outside_FinEdge",
          label: (isThrough),
          source_type: "saving",
          frequency: "monthly",
          amount: outsideFinEdge,
        },
        // {
        //   _id: "",
        //   field: "Through",
        //   label: isThrough,
        //   source_type: "saving",
        //   frequency: "monthly",
        //   amount: isThrough,
        // },

        // ...saveItemsInc.map((income, index) => ({
        //   _id: "",
        //   field: income.field,
        //   label: (income.label),
        //   source_type: "saving",
        //   frequency: "monthly",
        //   label2: "items",
        //   amount: income.amount,
        // })),
        
        
      ],
    };
    console.log("allData", allData,transformedItems);

    api
      .post(
       "advisor/save_user_about_5",
        allData
      )
      .then((response) => {
        socket.emit("navigate", { room: roomId, url: nextUrl2 });
        navigate(nextUrl);
        setIsNext(false)
        setSaveItemsInc([])
        console.log("empty ho gaya")
      })
      .catch((error) => {
        console.error("Error saving message:", error);
        setIsNext(false)
      });

    // console.log("allData", allData);
  };
  console.log("issetIsNext(true)", isNext);

  const handleBack = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");
    // const prevUrl = "/financial-better?clientId=" + roomId;
    
    const prevUrl = "/financial-plan?clientId=" + roomId;
    const prevUrl2 = "/financial-plan";

    console.log("here");
    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const handleFeeChange = (childId, value) => {
    console.log("ffff", childId, value);

    const updatedChildrenFees = childrenFees.map((fee) =>
      fee.child_id === childId ? { ...fee, amount: value } : fee
    );

    if (!childrenFees.some((fee) => fee.child_id === childId)) {
      updatedChildrenFees.push({ child_id: childId, amount: value });
    }
    console.log("childrenFees", childrenFees);
    setChildrenFees(updatedChildrenFees);
  };

  const handleAdditionalIncomeChange = (index, field) => (event) => {
    const value = event.target.value;
  
    // Capitalize label text before updating the state
    // const newValue = field === 'label' ? capitalizeText(value) : value;
    const newValue = field === 'label' ? value : value; 

    setAdditionalInc((prevSources) => {
      const newSources = prevSources.map((income, i) =>
        i === index 
          ? { ...income, [field]: newValue } // create new object with updated field
          : income
      );
      return newSources;
    });
  };
  
  // const handleOtherLoan = (index, field) => (event) => {
  //   const value = event.target.value;
  //   // Capitalize label text before updating the state
  //   const newValue = field === 'label' ? capitalizeText(value) : value;

  //   setotherLoanInc((prevSources) => {
  //     const newSources = [...prevSources];
  //     newSources[index][field] = newValue;
  //     return newSources;
  //   });

  // };
  
  const handleOtherLoan = (index, field) => (event) => {
    const value = event.target.value;
  
    // Capitalize label text before updating the state
    const newValue = field === 'label' ? capitalizeText(value) : value;
  
    setotherLoanInc((prevSources) => {
      const newSources = prevSources.map((loan, i) =>
        i === index
          ? { ...loan, [field]: newValue } // create new object with updated field
          : loan
      );
      return newSources;
    });
  };
  
  const handleMiscellaneousAmount = (index, field) => (event) => {
    const value = event.target.value;
  
    // Capitalize label text before updating the state
    const newValue = field === 'label' ? capitalizeText(value) : value;
  
    setAddMiscellaneousAmountInc((prevSources) => {
      const newSources = prevSources.map((item, i) =>
        i === index
          ? { ...item, [field]: newValue } // create new object with updated field
          : item
      );
      return newSources;
    });
  };
  
  const handleSavingItems = (index, field) => (event) => {
    const value = event.target.value;
    // Capitalize label text before updating the state
    const newValue = field === 'label' ? capitalizeText(value) : value;

    setSaveItemsInc((prevSources) => {
      const newSources = [...prevSources];
      newSources[index][field] = newValue;
      return newSources;
    });

  };
  const handleAddMoreIncome = () => {
    setAdditionalInc((prevSources) => [
      ...prevSources,
      { label: capitalizeText(""), amount: "" }, // Capitalize the label
    ]);
  };
  const handleAddMoreOtherLoan = () => {
    setotherLoanInc((prevSources) => [
      ...prevSources,
      { label: "", amount: "" },
    ]);
  };
  const handleAddMoreMiscellaneousAmount = () => {
    setAddMiscellaneousAmountInc((prevSources) => [
      ...prevSources,
      { label: "", amount: "" },
    ]);
  };


  const handleAddMoreSavingItems = () => {
    setSaveItemsInc((prevSources) => [
      ...prevSources,
      { label: "", amount: "", field: "" },
    ]);
  };

  const [allIncome, setAllIncome] = useState("0");
  const [series, setSeries] = useState([]);
  console.log("allIncome", allIncome);

  useEffect(() => {
    // const monthlyExpences = Number(groceryAmount) +Number(homeRunningAmount) + Number(transportationAmount);
    const monthlyIncomes = Number(monthlyIncome);

    // const monthlyEmi = Number(houseRentedAmount)+ Number(homeLoan)+Number(vehicleLoan)+Number(personalLoan)+Number(healthInsurance)+totalOtherLoanInc+Number(outsideFinEdge)
    // console.log("monthlyEmi",monthlyEmi,totalOtherLoanInc);

    const totalAdditionInc = addtionInc.reduce(
      (sum, item) => sum + Number(item.amount),
      0
    );
    const newAllIncome = Number(monthlyIncome) + totalAdditionInc;
    setAllIncome(String(newAllIncome));

    const totalOtherLoanInc = otherLoanInc.reduce(
      (sum, item) => sum + Number(item.amount),
      0
    );

    const monthlyHealthInc = Math.round(Number(healthInsurance) / 12);

    const loanAmount =
      Number(homeLoan) + Number(vehicleLoan) + totalOtherLoanInc;
    const totalMiscellaneousAmountInc = addMiscellaneousAmountInc.reduce(
      (sum, item) => sum + Number(item.amount),
      0
    );

    const totalSaveItemsInc = saveItemsInc.reduce(
      (sum, item) => sum + Number(item.amount),
      0
    );
    const monthlySavings =
      Number(outsideFinEdge) + totalSaveItemsInc + Number(futureGoals);

    const totalEducationFees = childrenFees.reduce(
      (sum, item) => sum + Number(item.amount),
      0
    );
    const monthlySurplus =
      newAllIncome -
      totalEducationFees -
      Number(groceryAmount) -
      Number(homeRunningAmount) -
      Number(transportationAmount) -
      Number(houseRentedAmount) -
      loanAmount -
      totalMiscellaneousAmountInc -
      monthlyHealthInc;

    // setSeries( [totalEducationFees, Number(homeRunningAmount), Number(transportationAmount),monthlySavings,monthlySurplus])
    setSeries([
      monthlySurplus,
      Number(totalEducationFees),
      Number(groceryAmount),
      Number(homeRunningAmount),
      Number(transportationAmount),
      Number(houseRentedAmount),
      loanAmount,
      monthlyHealthInc,
      totalMiscellaneousAmountInc,
      monthlySavings,
    ]);
  }, [
    monthlyIncome,
    addtionInc,
    childrenFees,
    groceryAmount,
    homeRunningAmount,
    transportationAmount,
    houseRentedAmount,
    healthInsurance,
    homeLoan,
    vehicleLoan,
    otherLoanInc,
    addMiscellaneousAmountInc,
    futureGoals,
    outsideFinEdge,
    saveItemsInc,
  ]);

  const options = {
    chart: {
      type: "donut",
    },
    labels: [
      "Monthly Surplus",
      "Education Fee",
      "Monthly grocery bill",
      "Home running expenses",
      "Fuel & Transportation costs",
      "House rent",
      "Loan Amount",
      " Amount",
      "Miscellaneous Amount",
      "Monthly Savings",
    ],
    colors: [
      "#123200",
      "#03641B",
      "#047D22",
      "#059529",
      "#2DC653",
      "#32F964",
      "#59FA81",
      "#80FC9F",
      "#CCFF33",
      "#F8AA24",
      "#F8AA20",
      "#B4E375",
      "#60BD3B",
      "#23674B",
      "#4DBD8F",
    ],
    plotOptions: {
      pie: {
        donut: {
          size: "90%",
          labels: {
            show: true,
            label: `₹${allIncome}`,
            total: {
              show: true,
              formatter: () => `₹${allIncome}`,
              color: isDarkMode ? '#fff' : '#000',
              fontSize: "28px",
              fontWeight: "400px"
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
      formatter: (val) => `${val.toFixed(0)}%`,
    },
    legend: {
      show: false,
      position: "bottom",
    },
    tooltip: {
      theme: "dark",
      style: {
        fontSize: "14px",
        color: "#fff",
      },
      // Customizing the tooltip background color
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return `<div style="background-color: #0009; padding: 10px; border-radius: 5px;">
                  <span>${w.globals.labels[seriesIndex]}: ${series[seriesIndex]}</span>
                </div>`;
      },
    },
  };
  console.log(monthlyIncome);

  // Function to navigate between pages
  const handleNextContent = () => {

    // Check if it's page 1
    // const isAnyAmountEmpty = childrenFees.some((fee) => !fee.amount);
    console.log('isAnyAmountEmpty',  childrenFees, childrenData);
    const isAnyIncomeEmpty = addtionInc.some((income) => !(income.label) || !income.amount);
    const isinstallments = otherLoanInc.some((income) => !(income.label) || !income.amount);
    const ismiscellaneousAmount = addMiscellaneousAmountInc.some((income) => !(income.label) || !income.amount);

    const feeChildIds = childrenFees.map(fee => fee.child_id);
    // Check if any child from childrenData is missing in childrenFees
    const hasMissingChild = childrenData.some(child => !feeChildIds.includes(child._id));
    console.log("hasMissingChild", hasMissingChild, feeChildIds);

    if (
      currentPage === 1 &&
      (!monthlyIncome || !groceryAmount || !homeRunningAmount || !transportationAmount || isAnyIncomeEmpty ||  hasMissingChild)
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please fill in all the required fields on this page.',
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn  ',
        },
      });

      return;
    }
    else if (
      currentPage === 2 &&
      (
        // !houseRentedAmount ||
        //  !homeLoan ||
        //   !vehicleLoan ||
        //    !healthInsurance ||
        isAnyIncomeEmpty ||
        // isAnyAmountEmpty ||
        isinstallments ||
        ismiscellaneousAmount)
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please fill in all the required fields on this page.',
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn  ',
        },
      });
      return;
    }

    // Proceed to the next page
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handleBackContent = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  // for AIDW modal
  const [showAIDWModal, setShowAIDWModal] = useState(false);
  const [deleteAIDWData, setDeleteAIDWData] = useState(null);
  const [deleteAIDWId, setDeleteAIDWId] = useState(null);
  const handleRemoveIncome = (index, data) => {
    setShowAIDWModal(true);
    setDeleteAIDWData(data);
    setDeleteAIDWId(index);
  };
  const handleConfirmDeleteAIDW = () => {
    setAdditionalInc((prevSources) =>
      prevSources.filter((_, i) => i !== deleteAIDWId)
    );
    setShowAIDWModal(false);
  };

  // for OLIDW
  const [showOLIDWModal, setShowOLIDWModal] = useState(false);
  const [deleteOLIDWData, setDeleteOLIDWData] = useState(null);
  const [deleteOLIDWId, setDeleteOLIDWId] = useState(null);
  const handleRemoveOtherLoan = (index, data) => {
    setShowOLIDWModal(true);
    setDeleteOLIDWData(data);
    setDeleteOLIDWId(index);
  };
  const handleConfirmDeleteOLIDW = () => {
    setotherLoanInc((prevSources) =>
      prevSources.filter((_, i) => i !== deleteOLIDWId)
    );
    setShowOLIDWModal(false);
  };

  useEffect(() => {
    if (addMiscellaneousAmountFlag === 'No') {
      setAddMiscellaneousAmountInc([]);
    }
    if (additionalIncomeFlag === 'No') {
      setAdditionalInc([]);
    }
    if (otherLoanFlag === 'No') {
      setotherLoanInc([]);
    }
  }, [addMiscellaneousAmountFlag, additionalIncomeFlag, otherLoanFlag,personalLoanChecked])
  // for MiscellaneousAmount
  const [showMDWModal, setShowMDWModal] = useState(false);
  const [deleteMDWData, setDeleteMDWData] = useState(null);
  const [deleteMDWId, setDeleteMDWId] = useState(null);
  const handleRemoveMiscellaneousAmount = (index, data) => {
    setShowMDWModal(true);
    setDeleteMDWData(data);
    setDeleteMDWId(index);
  };
  const handleConfirmDeleteMDW = () => {
    setAddMiscellaneousAmountInc((prevSources) =>
      prevSources.filter((_, i) => i !== deleteMDWId)
    );
    setShowMDWModal(false);
  };
  // for Items
  const [showIDWModal, setShowIDWModal] = useState(false);
  const [deleteIDWData, setDeleteIDWData] = useState(null);
  const [deleteIDWId, setDeleteIDWId] = useState(null);
  const handleRemoveSavingItems = (index, data) => {
    setShowIDWModal(true);
    setDeleteIDWData(data);
    setDeleteIDWId(index);
  };
  const handleConfirmDeleteIDW = () => {
    setSaveItemsInc((prevSources) =>
      prevSources.filter((_, i) => i !== deleteIDWId)
    );
    setShowIDWModal(false);
  };

  return (
    <>
      <Toaster position="top-center" />
      <AIDWModal
        showAIDWModal={showAIDWModal}
        setAIDWShowModal={setShowAIDWModal}
        handleConfirmDeleteAIDW={handleConfirmDeleteAIDW}
        deleteAIDWData={deleteAIDWData}
      />
      <OLIDWModal
        showAIDWModal={showOLIDWModal}
        setAIDWShowModal={setShowOLIDWModal}
        handleConfirmDeleteAIDW={handleConfirmDeleteOLIDW}
        deleteAIDWData={deleteOLIDWData}
      />
      <MDWModal
        showAIDWModal={showMDWModal}
        setAIDWShowModal={setShowMDWModal}
        handleConfirmDeleteAIDW={handleConfirmDeleteMDW}
        deleteAIDWData={deleteMDWData}
      />
      <IDWModal
        showAIDWModal={showIDWModal}
        setAIDWShowModal={setShowIDWModal}
        handleConfirmDeleteAIDW={handleConfirmDeleteIDW}
        deleteAIDWData={deleteIDWData}
      />
      <div className="container minht ">
        <div className="row  ">
          <div className="col-md-6 col-12 text-center posi">
            <Chart
              options={options}
              series={series}
              type="donut"
              width="90%"
            // height="350"
            />
          </div>

          <div className="col-md-6 col-12 mt-md-0">
            <div className="scroll-container">
              {currentPage === 1 && (
                <>
                  <div className="row my-2">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/dollar.png" alt="" />
                    </div>
                    <div className="col-md-8 col-7">
                      <p className="fs-21 ms-2">Your monthly income is</p>
                    </div>
                    <div className="col-md-3 col-4">
                      <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                        <span className="pt-1">₹</span>
                        <input
                          type="number"
                          name="monthlyIncome"
                          value={monthlyIncome}
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid green",
                          }}
                          placeholder="Amount"
                          className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                          onChange={(e) => { setMonthlyIncome(e.target.value) }}
                          onBlur={saveUserAbout}
                        />
                      </p>
                      {/* {monthlyIncome !== "" && isNaN(monthlyIncome) && (
                  <div className="text-danger mt-1">
                   
                    Please enter a valid numeric amount.
                  </div>
                )} */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/grocery.png" alt="" />
                    </div>
                    <div className="col-md-8 col-8">
                      <p className="fs-21 ms-2">
                        Additional sources of income?
                      </p>
                    </div>
                    <div className="col-md-3 col-3">
                      <select
                        className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                        value={additionalIncomeFlag}
                        onChange={(e) =>
                          setAdditionalIncomeFlag(e.target.value)
                        }
                        onBlur={saveUserAbout}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid green",
                        }}
                      >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  {additionalIncomeFlag === "Yes" &&
                    addtionInc.map((income, index) => (
                      <div className="row mt-3" key={index}>
                        <div className="col-md-1 col-1"></div>
                        <div className="col-md-5 col-4">
                          <input
                            type="text"
                            name={`incomeSource${index}`}
                            value={income.label}
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              borderBottom: errors[`label${index}`]
                                ? "1px solid red"
                                : "1px solid green",
                              outline: "none",
                            }}
                            required
                            placeholder="Income Source"
                            className=" txt-color reward24 fw-medium w-100 ps-2 moinput1 text-capitalize "
                            onChange={handleAdditionalIncomeChange(
                              index,
                              "label"
                            )}
                          />
                        </div>
                        <div className="col-md-4 col-4">
                          <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                            <span className="pt-1">₹</span>
                            <input
                              type="number"
                              name={`incomeAmount${index}`}
                              onBlur={saveUserAbout}
                              value={income.amount}
                              style={{
                                border: "none",
                                borderBottom: errors[`amount${index}`]
                                  ? "1px solid red"
                                  : "1px solid green",
                                outline: "none",
                              }}
                              required
                              placeholder="Amount"
                              className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                              onChange={handleAdditionalIncomeChange(
                                index,
                                "amount"
                              )}
                            />
                          </p>
                        </div>
                        <div className="col-md-2 col-2">
                          {/* {index !== 0 && ( */}
                          <MdOutlineCancel
                            onClick={() =>
                              handleRemoveIncome(index, income.label)
                            }
                            className="text-danger fs-4"
                          />
                          {/* )} */}
                        </div>
                      </div>
                    ))}

                  {additionalIncomeFlag === "Yes" && (
                    <div className="row mt-3">
                      <div className="col-md-1 col-1"></div>
                      <div className="col-11">
                        <button
                          type="button"
                          className="btn btn-success btn-sm mb-4"
                          onClick={handleAddMoreIncome}
                        >
                          Add More
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Other input fields */}
                  {childrenData?.map((child) => {
                    const fee = childrenFees?.find(
                      (fee) => fee?.child_id === child?._id
                    );

                    console.log('fesee',fee)

                    return (
                      <div key={child?._id} className="row my-2">
                        <div className="col-md-1 col-1">
                          <img src="assets/images/dollar.png" alt="dollar" />
                        </div>
                        <div className="col-md-8 col-7">
                          <p className="fs-21 ms-2">
                            You pay per month for{" "}
                            <span className="fw-bold clrgreen">
                              {child?.name}
                            </span>
                            's education
                          </p>
                        </div>
                        <div className="col-md-3 col-4">
                          <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                            <span className="pt-1">₹</span>
                            <input
                              type="number"
                              name={`childFee-${child._id}`}
                              value={fee && fee?.amount}
                              onBlur={saveUserAbout}
                              min={0} // prevent negative inputs
                              style={{
                                border: "none",
                                borderBottom: "1px solid green",
                                outline: "none",
                              }}
                              placeholder="Amount"
                              className="txt-color reward24 fw-medium w-100 ps-2 moinput1"
                              onChange={(e) =>
                                handleFeeChange(child._id, e.target.value)
                              } // Updated this line
                            />
                          </p>
                        </div>
                      </div>
                    );
                  })}

                  <div className="row">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/grocery.png" alt="" />
                    </div>
                    <div className="col-md-8 col-7">
                      <p className="fs-21 ms-2">Your monthly grocery bill</p>
                    </div>
                    <div className="col-md-3 col-4">
                      <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                        <span className="pt-1">₹</span>
                        <input
                          type="number"
                          name="groceryAmount"
                          value={groceryAmount}
                          onBlur={saveUserAbout}
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid green",
                          }}
                          placeholder=" Amount "
                          className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                          onChange={(e) => setGroceryAmount(e.target.value)}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/expense.png" alt="" />
                    </div>
                    <div className="col-md-8 col-7">
                      <p className="fs-21 ms-2">
                        Your monthly home running expenses
                      </p>
                    </div>
                    <div className="col-md-3 col-4">
                      <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                        <span className="pt-1">₹</span>
                        <input
                          type="number"
                          name="homeRunningAmount"
                          value={homeRunningAmount}
                          onBlur={saveUserAbout}
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid green",
                          }}
                          placeholder="Amount "
                          className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                          onChange={(e) => setHomeRunningAmount(e.target.value)}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/transportation-cost.png" alt="" />
                    </div>
                    <div className="col-md-8 col-7">
                      <p className="fs-21 ms-2">
                        Your monthly fuel & transportation costs
                      </p>
                    </div>
                    <div className="col-md-3 col-4">
                      <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                        <span className="pt-1">₹</span>
                        <input
                          type="number"
                          name="setTransportationAmount"
                          value={transportationAmount}
                          onBlur={saveUserAbout}
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid green",
                          }}
                          placeholder="Amount "
                          className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                          onChange={(e) =>
                            setTransportationAmount(e.target.value)
                          }
                        />
                      </p>
                    </div>
                  </div>
                  <IoIosArrowDropright
                    className="clrgreen fs-1 mx-auto w-100"
                    onClick={handleNextContent}
                  />
                </>
              )}
              {currentPage === 2 && (
                <>
                  {rentedHouseChecked && (
                    <div className="row my-2">
                      <div className="col-md-1 col-1">
                        <img src="assets/images/dollar.png" alt="" />
                      </div>
                      <div className="col-md-8 col-7">
                        <p className="fs-21 ms-2">Your monthly house rent is</p>
                      </div>
                      <div className="col-md-3 col-4">
                        <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                          <span className="pt-1">₹</span>
                          <input
                            type="number"
                            name="rentedHouseExpenses"
                            value={houseRentedAmount}
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              outline: "none",
                              borderBottom: "1px solid green",
                            }}
                            placeholder="Amount "
                            className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                            onChange={(e) =>
                              setHouseRentedAmount(e.target.value)
                            }
                          />
                        </p>
                      </div>
                    </div>
                  )}

                  {homeLoanChecked && (
                    <div className="row my-2">
                      <div className="col-md-1 col-1">
                        <img src="assets/images/dollar.png" alt="" />
                      </div>
                      <div className="col-md-8 col-7">
                        <p className="fs-21 ms-2">Your Home Loan EMI is </p>
                      </div>
                      <div className="col-md-3 col-4">
                        <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                          <span className="pt-1">₹</span>
                          <input
                            type="number"
                            name="rentedHouseExpenses"
                            value={homeLoan}
                            placeholder="Amount "
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              outline: "none",
                              borderBottom: "1px solid green",
                            }}
                            className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                            onChange={(e) => setHomeLoan(e.target.value)}
                          />
                        </p>
                      </div>
                    </div>
                  )}

                  {vehicleLoanChecked && (
                    <div className="row my-2">
                      <div className="col-md-1 col-1">
                        <img src="assets/images/dollar.png" alt="" />
                      </div>
                      <div className="col-md-8 col-7">
                        <p className="fs-21 ms-2">
                          Your Monthly Car Loan EMI is
                        </p>
                      </div>
                      <div className="col-md-3 col-4">
                        <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                          <span className="pt-1">₹</span>
                          <input
                            type="number"
                            name="rentedHouseExpenses"
                            onBlur={saveUserAbout}
                            value={vehicleLoan}
                            placeholder="Amount "
                            style={{
                              border: "none",
                              outline: "none",
                              borderBottom: "1px solid green",
                            }}
                            className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                            onChange={(e) => setVehicleLoan(e.target.value)}
                          />
                        </p>
                      </div>
                    </div>
                  )}

                  {healthInsuranceChecked && (
                    <div className="row my-2">
                      <div className="col-md-1 col-1">
                        <img src="assets/images/dollar.png" alt="" />
                      </div>
                      <div className="col-md-8 col-7">
                        <p className="fs-21 ms-2">
                          Your annually health insurance is
                        </p>
                      </div>
                      <div className="col-md-3 col-4">
                        <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                          <span className="pt-1">₹</span>
                          <input
                            type="number"
                            name="rentedHouseExpenses"
                            value={healthInsurance}
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              outline: "none",
                              borderBottom: "1px solid green",
                            }}
                            placeholder="Amount "
                            className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                            onChange={(e) => setHealthInsurance(e.target.value)}
                          />
                        </p>
                      </div>
                    </div>
                  )}

                  {personalLoanChecked && (
                    <>
                      <div className="row">
                        <div className="col-md-1 col-1">
                          <img src="assets/images/grocery.png" alt="" />
                        </div>
                        <div className="col-md-8 col-8">
                          <p className="fs-21 ms-2">
                            Your other loan installments?
                          </p>
                        </div>
                        <div className="col-md-3 col-3">
                          <select
                            className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                            value={otherLoanFlag}
                            onChange={(e) => setOtherLoanFlag(e.target.value)}
                            onBlur={saveUserAbout}
                            style={{
                              outline: "none",
                              border: "none",
                              borderBottom: "1px solid green",
                            }}
                          >
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                        </div>
                      </div>
                      {otherLoanFlag === "Yes" &&
                        otherLoanInc.map((loan, index) => (
                          <div className="row mt-3" key={index}>
                            <div className="col-md-1 col-1"></div>
                            <div className="col-md-5 col-5">
                              <input
                                type="text"
                                name={`otherLoanLabel${index}`}
                                value={loan.label}
                                onBlur={saveUserAbout}
                                style={{
                                  border: "none",
                                  borderBottom: errors[`otherLoanLabel${index}`]
                                    ? "1px solid red"
                                    : "1px solid green",
                                  outline: "none",
                                }}
                                placeholder="Description"
                                className="txt-color reward24 fw-medium w-100 ps-2 moinput1 text-capitalize"
                                onChange={handleOtherLoan(index, "label")}
                              />
                            </div>
                            <div className="col-md-5 col-4">
                              <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                                <span className="pt-1">₹</span>
                                <input
                                  type="number"
                                  name={`otherLoanAmount${index}`}
                                  value={loan.amount}
                                  onBlur={saveUserAbout}
                                  style={{
                                    border: "none",
                                    borderBottom: errors[
                                      `otherLoanAmount${index}`
                                    ]
                                      ? "1px solid red"
                                      : "1px solid green",
                                    outline: "none",
                                  }}
                                  placeholder="Amount"
                                  className="txt-color reward24 fw-medium w-100 ps-2 moinput1"
                                  onChange={handleOtherLoan(index, "amount")}
                                />
                              </p>
                            </div>
                            <div className="col-md-1 col-2">
                              <MdOutlineCancel
                                onClick={() =>
                                  handleRemoveOtherLoan(index, loan.label)
                                }
                                className="text-danger fs-4"
                              />
                            </div>
                          </div>
                        ))}

                      {otherLoanFlag === "Yes" && (
                        <div className="row mt-3">
                          <div className="col-md-1 col-1"></div>
                          <div className="col-11">
                            <button
                              type="button"
                              className="btn btn-success btn-sm mb-4"
                              onClick={handleAddMoreOtherLoan}
                            >
                              Add More
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  <div className="row">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/grocery.png" alt="" />
                    </div>
                    <div className="col-md-8 col-8">
                      <p className="fs-21 ms-2">
                        Would you like to put any amount under “miscellaneous” ?
                      </p>
                    </div>
                    <div className="col-md-3 col-3">
                      <select
                        className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                        value={addMiscellaneousAmountFlag}
                        onBlur={saveUserAbout}
                        onChange={(e) =>
                          setAddMiscellaneousAmountFlag(e.target.value)
                        }
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid green",
                        }}
                      >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  {addMiscellaneousAmountFlag === "Yes" &&
                    addMiscellaneousAmountInc.map((income, index) => (
                      <div className="row mt-3" key={index}>
                        <div className="col-md-1 col-1"></div>
                        <div className="col-md-5 col-5">
                          <input
                            type="text"
                            name={`miscLabel${index}`}
                            value={income.label}
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              borderBottom: errors[`miscLabel${index}`]
                                ? "1px solid red"
                                : "1px solid green",
                              outline: "none",
                            }}
                            placeholder="Description"
                            className="txt-color reward24 fw-medium w-100 ps-2 moinput1 text-capitalize"
                            onChange={handleMiscellaneousAmount(index, "label")}
                          />
                        </div>
                        <div className="col-md-4 col-4">
                          <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                            <span className="pt-1">₹</span>
                            <input
                              type="number"
                              name={`miscAmount${index}`}
                              value={income.amount}
                              onBlur={saveUserAbout}
                              style={{
                                border: "none",
                                borderBottom: errors[`miscAmount${index}`]
                                  ? "1px solid red"
                                  : "1px solid green",
                                outline: "none",
                              }}
                              placeholder="Amount"
                              className="txt-color reward24 fw-medium w-100 ps-2 moinput1"
                              onChange={handleMiscellaneousAmount(
                                index,
                                "amount"
                              )}
                            />
                          </p>
                        </div>
                        <div className="col-md-2 col-2">
                          <MdOutlineCancel
                            onClick={() =>
                              handleRemoveMiscellaneousAmount(
                                index,
                                income.label
                              )
                            }
                            className="text-danger fs-4"
                          />
                        </div>
                      </div>
                    ))}

                  {addMiscellaneousAmountFlag === "Yes" && (
                    <div className="row mt-3">
                      <div className="col-md-1 col-1"></div>
                      <div className="col-11">
                        <button
                          type="button"
                          className="btn btn-success btn-sm mb-4"
                          onClick={handleAddMoreMiscellaneousAmount}
                        >
                          Add More
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="d-flex justify-content-center">
                    <IoIosArrowDropleft
                      className=" clrgreen fs-1"
                      onClick={handleBackContent}
                    />
                    <IoIosArrowDropright
                      className=" clrgreen fs-1"
                      onClick={handleNextContent}
                    />
                  </div>
                </>
              )}
              {currentPage === 3 && (
                <>
                  <div className="row my-2">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/expense.png" alt="" />
                    </div>
                    <div className="col-md-8 col-8">
                      <p className="fs-21 ms-2">
                        How much are you investing every month for your future
                        goals? Mutual Funds (through FinEdge)*
                      </p>
                    </div>
                    <div className="col-md-3 col-3">
                      <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                        <span className="pt-1">₹</span>
                        <input
                          type="number"
                          name="futureGoals"
                          value={futureGoals}
                          onBlur={saveUserAbout}
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid green",
                          }}
                          placeholder="Amount"
                          className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                          onChange={(e) => setFutureGoals(e.target.value)}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-1 col-1">
                      <img src="assets/images/expense.png" alt="" />
                    </div>
                    <div className="col-md-8 col-8">
                      <p className="fs-21 ms-2">
                        Mutual Funds (outside of FinEdge)*{" "}
                      </p>
                    </div>
                    <div className="col-md-3 col-3">
                      <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                        <span className="pt-1">₹</span>
                        <input
                          type="number"
                          name="outsideFinEdge"
                          value={outsideFinEdge}
                          onBlur={saveUserAbout}
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid green",
                          }}
                          placeholder="Amount"
                          className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                          onChange={(e) => setOutsideFinEdge(e.target.value)}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-1 col-1"></div>
                    <div className="col-md-3 col-8">
                      <p className="fs-21 ms-2">through</p>
                    </div>
                    <div className="col-md-5 col-3">
                      <select
                        className=" txt-color reward24 fw-medium w-100 ps-2 moinput1"
                        value={isThrough}
                        onChange={(e) => setThrough(e.target.value)}
                        onBlur={saveUserAbout}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid green",
                        }}
                      >
                        <option value="" selected>Select</option>
                        <option value="Groww">Groww</option>{" "}
                        <option value="IND Money">IND Money</option>{" "}
                        <option value="Scripbox">Scripbox</option>{" "}
                        <option value="ICICI Bank">ICICI Bank</option>{" "}
                        <option value="HDFC Bank">HDFC Bank</option>{" "}
                        <option value="Axis Bank">Axis Bank</option>{" "}
                        <option value="ICICI Direct">ICICI Direct</option>{" "}
                        <option value="Paytm">Paytm</option>{" "}
                        <option value="Zerodha">Zerodha</option>{" "}
                        <option value="ET Money">ET Money</option>{" "}
                        <option value="NJ Wealth">NJ Wealth</option>{" "}
                        <option value="Sharekhan">Sharekhan</option>{" "}
                        <option value="Angel Broking">Angel Broking</option>{" "}
                        <option value="Local Advisor">Local Advisor</option>{" "}
                        <option value="Funds India">Funds India</option>
                      </select>
                    </div>
                  </div>

                  {saveItemsInc.map((income, index) => (
                    <div className="row mt-3" key={index}>
                      <div className="col-md-1 col-1 d-none d-md-block"></div>
                      <div className="col-md-3 col-3">
                        <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                          <span className="pt-1">₹</span>
                          <input
                            type="number"
                            name={`saveamount${index}`}
                            value={income.amount}
                            onBlur={saveUserAbout}
                            style={{
                              border: "none",
                              outline: "none",
                              borderBottom: errors[`saveAmount${index}`]
                                ? "1px solid red"
                                : "1px solid green",
                            }}
                            placeholder="Amount"
                            className="txt-color reward24 fw-medium w-100 ps-2 moinput1"
                            onChange={handleSavingItems(index, "amount")}
                          />
                        </p>
                      </div>
                      <div className="col-md-4 col-4">
                        <select
                          className="txt-color reward24 fw-medium w-100 ps-2 moinput1"
                          value={income.field}
                          onChange={handleSavingItems(index, "field")}
                          onBlur={saveUserAbout}
                          style={{
                            border: "none",
                            outline: "none",
                            borderBottom: errors[`saveLabel${index}`]
                              ? "1px solid red"
                              : "1px solid green",
                          }}
                        >
                          <option value="">Select</option>
                          <option value="Mutual Fund">Mutual Fund</option>
                          <option value="Recurring Deposit">Recurring Deposit</option>
                          <option value="ULIP">ULIP</option>
                          <option value="Traditional Life Insurance">Traditional Life Insurance</option>
                          <option value="Gold Savings Scheme">Gold Savings Scheme</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                      <div className="col-md-3 col-3">
                        <p className="txt-color reward24 fw-medium w-100  moinput1 d-flex">
                          <input
                            type="text"
                            onBlur={saveUserAbout}
                            name={`saveDesc${index}`}
                            value={income.label}
                            style={{
                              border: "none",
                              outline: "none",
                              borderBottom: errors[`saveField${index}`]
                                ? "1px solid red"
                                : "1px solid green",
                            }}
                            placeholder="Description"
                            className="txt-color reward24 fw-medium w-100 ps-2 moinput1 text-capitalize"
                            onChange={handleSavingItems(index, "label")}
                          />
                        </p>
                      </div>
                      <div className="col-md-1 col-1">
                        <MdOutlineCancel
                          onClick={() =>
                            handleRemoveSavingItems(index, income.label)
                          }
                          className="text-danger fs-4"
                        />
                      </div>
                    </div>
                  ))}

                  <div className="row mt-3">
                    <div className="col-md-1"></div>
                    <div className="col-11">
                      <button
                        type="button"
                        className="btn btn-success btn-sm mb-4"
                        onClick={handleAddMoreSavingItems}
                      >
                        Add More
                      </button>
                    </div>
                  </div>
                  <IoIosArrowDropleft
                    className="fs-1 clrgreen mx-auto w-100"
                    onClick={handleBackContent}
                  />
                </>
              )}
            </div>
          </div>
        </div>
        {currentPage && currentPage === 1 && (
          <div className="row mt-5 row-cols-md-5 row-cols-2">
            <div className="col-md-2 d-lg-flex align-items-lg-center">
              <input
                type="checkbox"
                id="rented-house"
                name="houseRentedAmount"
                value="Rented House"
                onBlur={saveUserAbout}
                checked={rentedHouseChecked}
                onChange={handleRentedHouseChange}
              />
              <label htmlFor="rented-house" className="fs-18 ms-2">
                Rented House?
              </label>
              <br />
            </div>
            <div className="col-md-2 d-lg-flex align-items-lg-center">
              <input
                type="checkbox"
                id="home-loan"
                name="homeLoan"
                onBlur={saveUserAbout}
                value="Home Loan"
                checked={homeLoanChecked}
                onChange={handleHomeLoanChange}
              />
              <label htmlFor="home-loan" className="fs-18 ms-2">
                Home Loan?
              </label>
              <br />
            </div>
            <div className="col-md-2 d-lg-flex align-items-lg-center">
              <input
                type="checkbox"
                id="vehicle-loan"
                name="vehicleLoan"
                value="Vehicle Loan"
                checked={vehicleLoanChecked}
                onChange={handleVehicleLoanChange}
              />
              <label htmlFor="vehicle-loan" className="fs-18 ms-2">
                Car Loan?
              </label>
              <br />
            </div>
            <div className="col-md-2 d-lg-flex align-items-lg-center">
              <input
                type="checkbox"
                id="personal-loan"
                onBlur={saveUserAbout}
                name="personalLoan"
                value="Personal Loan"
                checked={personalLoanChecked}
                onChange={handlePersonalLoanChange}
              />
              <label htmlFor="personal-loan" className="fs-18 ms-2">
                Personal Loan?
              </label>
              <br />
            </div>


            <div className="col-md-2 d-flex align-items-center gap-2">
              <input
                type="checkbox"
                id="health-loan"
                name="healthLoan"
                onBlur={saveUserAbout}
                value="Health Loan"
                checked={healthInsuranceChecked}
                onChange={handleHealthInsuranceChange}
              />
              <label
                htmlFor="health-loan"
                className="fs-18"
                style={{ whiteSpace: "nowrap" }} // Prevents text from breaking into a new line
              >
                Health Insurance?
              </label>
            </div>


          </div>

        )}
      </div>
      <div className="container" >
        <div className="row mb-4">
          <div className="col text-end" >
            {/* { !isNext? "next":"nexting..."} */}
            <a onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>

            <a href="javascript:void(0);" className="ms-1"
              onClick={!isNext ? handleNext : undefined}  >
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""

              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Graph;
